import React from 'react';
import * as Inovx from '@shared';
import FacilityActions from '../actions/FacilityActions';
import OntologyActions from '../actions/OntologyActions';
import FacilityStore from '../stores/FacilityStore';
import FacilityConstants from '../constants/FacilityConstants';
import AssemblyLibrary from './AssemblyLibrary';
import AssemblyLibraryStore from '../stores/AssemblyLibraryStore';
import FacilityForm from './FacilityForm';
import TaxonomyForm from './TaxonomyForm';
import ManageSidebar from './ManageSidebar';
import FacilityView from './FacilityView';
import FacilityHierarchyForm from './FacilityHierarchyForm';
import DataSourcesPage from '../dataSources/components/DataSourcesPage';
import ConfigurationForm from './configuration/ConfigurationForm';
var ListHelper = Inovx.Shared.Common.ListHelper;
var PermissionService = Inovx.Shared.Permission.PermissionService;
var MANAGE_FACILITY_PERMISSION = "Facility.Manage";

declare var InovxLoader: any;
const facilityImg = `data:image/png;base64,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`;

interface FacilityMaintenanceProps {
    // Empty for now, can be extended if needed
}

interface FacilityMaintenanceState {
    allFacilities?: IFacility[];
    selectedFacility?: IFacilityDetail;
    modalVisible?: boolean;
    sidebarOpen?: boolean;
    configurationModalVisible?: boolean;
    taxonomyModalVisible?: boolean;
    ontologyModalVisible?: boolean;
    assemblyLibraryVisible?: boolean;
    dataSourcesVisible?: boolean;
}

function getFacilityMaintenanceState(): FacilityMaintenanceState {
    return {
        allFacilities: FacilityStore.getAll(),
        selectedFacility: FacilityStore.getSelectedFacility(),
        modalVisible: FacilityStore.getModalVisible(),
        sidebarOpen: FacilityStore.getSidebarOpen(),
        configurationModalVisible: FacilityStore.getConfigurationModalVisible(),
        taxonomyModalVisible: FacilityStore.getTaxonomyModalVisible(),
        ontologyModalVisible: FacilityStore.getOntologyModalVisible(),
        assemblyLibraryVisible: AssemblyLibraryStore.getAssemblyLibraryVisible(),
        dataSourcesVisible: FacilityStore.getDataSourcesVisible(),
    } as FacilityMaintenanceState
}

class ManageApp extends React.Component<FacilityMaintenanceProps, FacilityMaintenanceState> {
    
    constructor(props: FacilityMaintenanceProps, context: any) {
        super(props, context);
        this.state = getFacilityMaintenanceState();
    }

    private _onChange = () => {
        this.setState(getFacilityMaintenanceState());
    }

    private async _onFacilityClicked(facility: IFacility) {   
        FacilityActions.updateManageURL({ facilityId: facility.ID });
        await FacilityActions.openFacilityDetail(facility.ID);
        OntologyActions.beginEditOntology();
    }

    componentDidMount() {
        FacilityStore.addChangeListener(this._onChange);
        AssemblyLibraryStore.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        FacilityStore.removeChangeListener(this._onChange);
        AssemblyLibraryStore.removeChangeListener(this._onChange);
    }

    public render() {
        const dataSource = this.state.allFacilities ? ListHelper.sort(this.state.allFacilities, "Name") : [];
        const hasManagePermission: boolean = PermissionService.checkPermission(MANAGE_FACILITY_PERMISSION);
        const facilityIsSelected: boolean = !!this.state.selectedFacility;

        return (
            <>
                <Inovx.Shared.Controls.ActionInProgressLoader actionKey={[FacilityConstants.FACILITY_DETAILS, FacilityConstants.FACILITY_ADD, FacilityConstants.FACILITY_EDIT, FacilityConstants.FACILITY_DELETE, FacilityConstants.FACILITY_ADAPTERS]} class={'temp-modal-loader'}>
                    <div className="action-in-progress-loader-sm"></div>
                </Inovx.Shared.Controls.ActionInProgressLoader>
                <ManageSidebar />
                <div className="facility-app-container view-collapsed">
                    {facilityIsSelected ? (
                        this.state.modalVisible ? (
                            hasManagePermission ? <FacilityForm /> : <FacilityView />
                        ) : this.state.ontologyModalVisible ? (
                            <FacilityHierarchyForm />
                        ) : this.state.dataSourcesVisible ? (
                            <DataSourcesPage facility={this.state.selectedFacility} />
                        ) : null
                    ) : this.state.modalVisible ? (
                        <FacilityForm />
                    ) : this.state.configurationModalVisible ? (
                        <ConfigurationForm />
                    ) : this.state.taxonomyModalVisible ? (
                        <TaxonomyForm />
                    ) : this.state.assemblyLibraryVisible ? (
                        <AssemblyLibrary />
                    ) : (
                        <FacilityList dataSource={dataSource} onFacilityClicked={this._onFacilityClicked} />
                    )}
                </div>
            </>
        );
    }
}

const FacilityList: React.FC<{ dataSource: IFacility[]; onFacilityClicked: (facility: IFacility) => void }> = ({ dataSource, onFacilityClicked }) => (
    <div className='control-pane'>
        <div className="facility-app-content">
            <ul className="facility-app-list">
                {dataSource.map((item, key) => (
                    <li className="fa-view" key={key}>
                        <div onClick={() => onFacilityClicked(item)} className="fa-icon-image-container">
                            <div className="card cursor-pointer f-card">
                                <div className="card-body">
                                    <div className="card-image">
                                        <img src={item.ThumbnailImageUrl ? item.ThumbnailImageUrl : facilityImg} />
                                    </div>
                                    <div className="heading-1 my-3">{item.Name}</div>
                                    <div className="heading-2">{item.Location}</div>
                                    <p className="card-text">{item.Synopsis}</p>
                                </div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
            {(!dataSource || dataSource.length === 0) && (
                <div className="row">
                    <div className="col-md-12 d-flex j-cc a-ic">
                        {InovxLoader.t('facility:message.noFacilityExistsYet')}
                    </div>
                </div>
            )}
        </div>
    </div>
);

export default ManageApp;